import { isPlatformServer } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AppRequestContextService } from 'apps/pedixapp/src/app/app-request-context.service';

export const productTagExistsGuardFn: CanActivateFn = (routeSnapshot: ActivatedRouteSnapshot) => {
  const appRequestContext = inject(AppRequestContextService);
  const router = inject(Router);
  const platformId = inject(PLATFORM_ID);

  // NOTE: tag id is in search query params, which is not available on SSR; guard will be executed again on the browser
  if (isPlatformServer(platformId)) {
    return true;
  }

  const { t: tagId } = routeSnapshot.queryParams;

  const productTag = appRequestContext.productTags().find(productTag => {
    return tagId === productTag.id || tagId === productTag.slug;
  });

  if (!productTag) {
    return router.createUrlTree(['/']);
  }
  return true;
};
